import React, {Component} from 'react'

import Header from '../components/Header/header';
import HeroSection from '../components/HeroSection/heroSection2';
import PromoSection from '../components/PromoSection/Promo2';
import AboutSection from '../components/AboutUs/AboutUs2';
import Video from '../components/Video';
import ServiceSection from '../components/Service/Service2';
import Pricing from '../components/Pricing';
import Testimonial from '../components/Testimonial';
import Contact from '../components/Contact';
import ActionToCall from '../components/ActionToCall';
import Footer from '../components/footer/footer';


class Theme2 extends Component{
    render(){
        return(
            <div>
                <Header />
                <div className="main">
                    <HeroSection />
                    <PromoSection />
                    <AboutSection />
                    <Video />
                    <ServiceSection />
                    <Pricing />
                    <Testimonial />
                    <Contact />
                    <ActionToCall />
                </div>
                <Footer />
            </div>
        )
    }
}

export default Theme2